import { theme as uiTheme } from '@oneform/ui-components';

const theme = {
	...uiTheme
};

export default theme;
